import { DatePicker, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import {
  RequestForInformation,
  useRFITrackerContext,
} from '../../../../../../../RFITrackerContext'
import CIMSSelect from 'components/CIMSSelect'
import CIMSComment from 'components/CIMSComment'
import { useRespondedResponseDisciplineOptions } from '../../../../useRespondedResponseDisciplineOptions'
import { useWorkflowRollbackComment } from 'components/CIMSComment/hooks/useWorkflowRollbackComment'

const Help = HelpMessage.RequestsForInformation.RFITracker

export const DraftFormItems: React.FC<Partial<RequestForInformation>> = ({
  responses,
}) => {
  const {
    metadata,
    selectOptions: { organizationOptions },
  } = useRFITrackerContext()
  const responseDisciplineOptions = useRespondedResponseDisciplineOptions({
    rfiResponses: responses ?? [],
    allResponseDisciplines: metadata?.rfiResponseDisciplines,
  })
  return (
    <>
      <CIMSFormItem
        name="description"
        label="Description"
        requiredMessage="Please enter a description"
        help={HelpMessage.Description('Request For Information')}
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="organizationId"
        label="Submitting Organization"
        help={Help.Organization}
      >
        <CIMSSelect simple options={organizationOptions} />
      </CIMSFormItem>
      <CIMSFormItem
        name="requestedResponseDate"
        label="Requested Response Date"
        help={Help.ResponseDate}
      >
        <DatePicker allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        name="responseDisciplineIds"
        label="Response Disciplines"
        help={Help.ResponseDisciplines}
      >
        <CIMSSelect
          simple
          multiple
          // have to do this to prevent allowClear from clearing disabled options
          allowClear={false}
          options={responseDisciplineOptions}
        />
      </CIMSFormItem>
      <CIMSFormItem {...useWorkflowRollbackComment()}>
        <CIMSComment />
      </CIMSFormItem>
    </>
  )
}
